import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { FaBullhorn, FaFileContract, FaHandHoldingUsd, FaHome } from 'react-icons/fa';
import './sidebar.css'
import { FaFileLines, FaPeopleLine } from 'react-icons/fa6';
import { MdCampaign, MdCloudUpload, MdNotificationsActive } from 'react-icons/md';
import { collapse } from '../redux/reducer/SideBarReducer';
const Sidebar = () => {
  const dispatch = useDispatch();
  const isCollapsed = useSelector((state) => state.sidebar.value);
  const handleSidebarToggle = () => {
    if (window.innerWidth < 768) {
      dispatch(collapse())
    }

  };
  return (
    <aside className={`sidebar ${isCollapsed ? "collapsed" : ""}`}>
      <nav>
        <ul>
          <li>
            <Link to="/dashboard/home" onClick={handleSidebarToggle}>
              <FaHome size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Home</span>}
            </Link>
          </li>
          <li>
            <Link to="/dashboard/upload-images" onClick={handleSidebarToggle}>
              <MdCloudUpload size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Manage Images</span>}
            </Link>
          </li>

          {/* <li>
            <Link to="/dashboard/upload-advertisement" onClick={handleSidebarToggle}>
              <FaBullhorn onsActive size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Manage Advertisement</span>}
            </Link>
          </li> */}
          {/* <li>
            <Link to="/dashboard/upload-result" onClick={handleSidebarToggle}>
              <FaFileLines size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Manage Result</span>}
            </Link>
          </li> */}



          <li>
            <Link to="/dashboard/upload-notification" onClick={handleSidebarToggle}>
              <MdNotificationsActive size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Manage Notifications</span>}
            </Link>
          </li>
          {/* <li>
            <Link to="/dashboard/upload-tender" onClick={handleSidebarToggle}>
              <FaFileContract size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Manage Tender</span>}
            </Link>
          </li> */}

          {/* <li>
            <Link to="/dashboard/upload-notice" onClick={handleSidebarToggle}>
              <MdCampaign size={24} className='icon' />
              {!isCollapsed && <span className='ms-3'>Public Notice</span>}
            </Link>
          </li> */}


        </ul>
      </nav>
    </aside>
  );
}

export default Sidebar
